import React, { useState, useEffect } from 'react';
import { Container, Card, Button, Row, Col, Form } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import Header from '~/Components/Header/Header';
import AuthStorage from '~/Utils/AuthStorage';
import { caracteristicas } from '~/constant';
import { customStyles as selectStyles } from '~/Styles/reactSelectStyles';
import * as api from '~/Services/Service';
import { salvarEmPdf } from '~/Utils/Helpers';
import GradeQuadraLote from './GradeQuadraLote';
import GridTabularImoveis from './GridTabularImoveis';
import LegendaContadores from './LegendaContadores';
import PainelSemQuadra from './PainelSemQuadra';
import ModalDetalhe from './ModalDetalhe';
import MenuContexto from './MenuContexto';
import ModalVincularProposta from './ModalVincularProposta';
import './ConsultaImoveis.css';

var ConsultaImoveis = () => {
  var empreendimentosState = useState([]);
  var empreendimentos = empreendimentosState[0]; var setEmpreendimentos = empreendimentosState[1];

  var empreendimentoSelState = useState(null);
  var empreendimentoSelecionado = empreendimentoSelState[0];
  var setEmpreendimentoSelecionado = empreendimentoSelState[1];

  var imoveisState = useState([]);
  var imoveis = imoveisState[0]; var setImoveis = imoveisState[1];

  var contadoresState = useState(null);
  var contadores = contadoresState[0]; var setContadores = contadoresState[1];

  var ativosSemQuadraState = useState([]);
  var ativosSemQuadra = ativosSemQuadraState[0]; var setAtivosSemQuadra = ativosSemQuadraState[1];

  var loadingState = useState(false);
  var loading = loadingState[0]; var setLoading = loadingState[1];

  var modalDetalheState = useState(false);
  var modalDetalhe = modalDetalheState[0]; var setModalDetalhe = modalDetalheState[1];

  var detalheState = useState(null);
  var detalhe = detalheState[0]; var setDetalhe = detalheState[1];

  var imovelMapaSelState = useState(null);
  var imovelMapaSel = imovelMapaSelState[0]; var setImovelMapaSel = imovelMapaSelState[1];

  var loadingDetalheState = useState(false);
  var loadingDetalhe = loadingDetalheState[0]; var setLoadingDetalhe = loadingDetalheState[1];

  var menuCtxState = useState({ visible: false, x: 0, y: 0, imovel: null });
  var menuCtx = menuCtxState[0]; var setMenuCtx = menuCtxState[1];

  var modalPropostaState = useState(false);
  var modalProposta = modalPropostaState[0]; var setModalProposta = modalPropostaState[1];

  var imovelPropostaState = useState(null);
  var imovelProposta = imovelPropostaState[0]; var setImovelProposta = imovelPropostaState[1];

  var filtrosStatusState = useState([]);
  var filtrosStatus = filtrosStatusState[0]; var setFiltrosStatus = filtrosStatusState[1];

  var gerandoEspelhoState = useState(false);
  var gerandoEspelho = gerandoEspelhoState[0]; var setGerandoEspelho = gerandoEspelhoState[1];

  var visualizacaoState = useState('mapa');
  var visualizacao = visualizacaoState[0]; var setVisualizacao = visualizacaoState[1];

  var controlaPropostaVda = empreendimentoSelecionado
    ? empreendimentoSelecionado.controla_proposta_vda : '';

  useEffect(() => {
    api.consultaImoveisBuscarEmpreendimentos()
      .then((res) => {
        var lista = res.data || res;
        var opcoes = lista.map((e) => ({
          value: e.codigo_familia,
          label: e.nome_da_familia,
          controla_proposta_vda: e.controla_proposta_vda,
          vda_ticket: e.vda_ticket, // TODO: usar para controlar visibilidade de opcoes de ticket no MenuContexto
        }));
        setEmpreendimentos(opcoes);
      })
      .catch((err) => {
        var msg = err && err.message ? err.message : 'Erro ao carregar empreendimentos';
        toast.error(msg);
      });
  }, []);

  var handleBuscar = () => {
    if (!empreendimentoSelecionado) {
      toast.error('Selecione um empreendimento.');
      return;
    }
    setLoading(true);
    setImoveis([]);
    setContadores(null);
    setAtivosSemQuadra([]);
    setFiltrosStatus([]);

    api.consultaImoveisBuscarMapa({ codigo_familia: empreendimentoSelecionado.value })
      .then((res) => {
        var data = res.data || res;
        setImoveis(data.imoveis || []);
        setContadores(data.contadores || null);
        setAtivosSemQuadra(data.ativos_sem_quadra || []);
      })
      .catch((err) => {
        var msg = err && err.message ? err.message : 'Erro ao buscar mapa';
        toast.error(msg);
      })
      .finally(() => setLoading(false));
  };

  var handleCancelar = () => {
    setImoveis([]);
    setContadores(null);
    setAtivosSemQuadra([]);
    setFiltrosStatus([]);
  };

  var handleEspelhoVendas = () => {
    if (!empreendimentoSelecionado) {
      toast.error('Selecione um empreendimento.');
      return;
    }
    var codigoFamilia = empreendimentoSelecionado.value;
    setGerandoEspelho(true);
    salvarEmPdf(
      api.consultaImoveisEspelhoVendasUrl(codigoFamilia),
      'EspelhoVendas_' + codigoFamilia + '.pdf'
    )
      .catch((err) => {
        var msg = err && err.message ? err.message : 'Erro ao gerar Espelho de Vendas';
        toast.error(msg);
      })
      .finally(() => setGerandoEspelho(false));
  };

  var handleLoteDoubleClick = (imovel) => {
    // Fiel ao Delphi UConsultaImovel.pas (dbGridLoteDblClick linhas 126-129):
    // o formulario de alteracao so abre para status B, R ou D. Demais status
    // (V, P, A, O) nao respondem ao double-click.
    if (imovel.status !== 'B' && imovel.status !== 'R' && imovel.status !== 'D') {
      return;
    }

    setImovelMapaSel(imovel);
    setDetalhe(null);
    setModalDetalhe(true);
    setLoadingDetalhe(true);

    api.consultaImoveisBuscarDetalhe(imovel.codigo_ativo)
      .then((res) => {
        var data = res.data || res;
        setDetalhe(data);
      })
      .catch((err) => {
        var msg = err && err.message ? err.message : 'Erro ao buscar detalhe';
        toast.error(msg);
        setModalDetalhe(false);
      })
      .finally(() => setLoadingDetalhe(false));
  };

  var handleLoteContextMenu = (e, imovel) => {
    setMenuCtx({ visible: true, x: e.clientX, y: e.clientY, imovel });
  };

  const handleMenuAction = (acao, imovel) => {
    if (acao === 'vincular-proposta') {
      setImovelProposta(imovel);
      setModalProposta(true);
      return;
    }
    if (acao === 'cancelar-vinculo') {
      const confirma = window.confirm('Confirma o cancelamento do vínculo com a proposta?');
      if (!confirma) return;
      api.consultaImoveisCancelarVinculoProposta({ codigo_ativo: imovel.codigo_ativo })
        .then(() => {
          toast.success('Vínculo cancelado com sucesso.');
          handleBuscar();
        })
        .catch((err) => {
          const msg = err && err.message ? err.message : 'Erro ao cancelar vínculo';
          toast.error(msg);
        });
      return;
    }
    if (acao === 'reserva-especial') {
      api.consultaImoveisReservaEspecial({
        codigo_ativo: imovel.codigo_ativo,
        codigo_familia: empreendimentoSelecionado ? empreendimentoSelecionado.value : 0,
      })
        .then((res) => {
          const data = res.data || res;
          toast.success(data.marcado ? 'Reserva Especial marcada.' : 'Reserva Especial removida.');
          handleBuscar();
        })
        .catch((err) => {
          const msg = err && err.message ? err.message : 'Erro ao alterar Reserva Especial';
          toast.error(msg);
        });
      return;
    }
    if (acao === 'reserva-casa') {
      api.consultaImoveisReservaCasa({
        codigo_ativo: imovel.codigo_ativo,
        codigo_familia: empreendimentoSelecionado ? empreendimentoSelecionado.value : 0,
      })
        .then((res) => {
          const data = res.data || res;
          toast.success(data.marcado ? 'Reserva Casa marcada.' : 'Reserva Casa removida.');
          handleBuscar();
        })
        .catch((err) => {
          const msg = err && err.message ? err.message : 'Erro ao alterar Reserva Casa';
          toast.error(msg);
        });
      return;
    }
  };

  // Delphi dbGridLoteMouseDown (UConsultaImovel.pas 2424-2456):
  // Shift+Click -> Reserva Especial; Ctrl+Click -> Reserva Casa
  const handleLoteClick = (e, imovel) => {
    if (!imovel || imovel.status !== 'D') return;
    if (e.shiftKey) {
      if (!AuthStorage.temCaracteristicas([caracteristicas.ReservaEspecial])) return;
      if (imovel.tem_reserva_casa === 1) return;
      handleMenuAction('reserva-especial', imovel);
      return;
    }
    if (e.ctrlKey) {
      if (imovel.tem_reserva_especial === 1) return;
      handleMenuAction('reserva-casa', imovel);
    }
  };

  var handleAlterarStatus = (request) => {
    return api.consultaImoveisAlterarStatus(request);
  };

  var handleVincularProposta = (request) => {
    return api.consultaImoveisVincularProposta(request).then((res) => {
      handleBuscar();
      return res;
    });
  };

  return (
    <Container fluid className="px-3 py-3">
      <Header title="Consulta Mapa Empreendimento" />

      <Card className="shadow-sm mb-3 mt-3">
        <Card.Body className="py-2">
          <Row className="align-items-end">
            <Col xs={12} md={5} className="mb-2 mb-md-0">
              <label style={{ fontSize: 12, marginBottom: 2 }}>Empreendimento</label>
              <Select
                styles={selectStyles}
                options={empreendimentos}
                value={empreendimentoSelecionado}
                onChange={(op) => {
                  setEmpreendimentoSelecionado(op);
                  setImoveis([]);
                  setContadores(null);
                  setAtivosSemQuadra([]);
                }}
                placeholder="Selecione o empreendimento..."
                isClearable
              />
            </Col>
            <Col xs="auto" className="mb-2 mb-md-0">
              <Button
                variant="primary"
                size="sm"
                onClick={handleBuscar}
                disabled={loading || !empreendimentoSelecionado}
              >
                {loading ? 'Buscando...' : 'Buscar'}
              </Button>
            </Col>
            <Col xs="auto" className="mb-2 mb-md-0">
              <Button variant="secondary" size="sm" onClick={handleCancelar}>
                Cancela
              </Button>
            </Col>
            <Col xs="auto" className="mb-2 mb-md-0">
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={handleEspelhoVendas}
                disabled={!empreendimentoSelecionado || gerandoEspelho}
              >
                {gerandoEspelho ? 'Gerando PDF...' : 'Espelho de Vendas'}
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="shadow-sm">
        <Card.Header
          style={{
            backgroundColor: '#0747a6',
            color: 'white',
            padding: '6px 12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <strong style={{ fontSize: 14 }}>
            {visualizacao === 'mapa' ? 'Mapa de Lotes' : 'Grid de Lotes'}
          </strong>
          <div className="visualizacao-switch">
            <span style={{ opacity: visualizacao === 'mapa' ? 1 : 0.6 }}>Mapa</span>
            <Form.Check
              type="switch"
              id="switch-visualizacao-imoveis"
              checked={visualizacao === 'grid'}
              onChange={(e) => setVisualizacao(e.target.checked ? 'grid' : 'mapa')}
              label=""
              style={{ marginBottom: 0 }}
            />
            <span style={{ opacity: visualizacao === 'grid' ? 1 : 0.6 }}>Grid</span>
          </div>
        </Card.Header>
        <Card.Body className="p-0">
          {visualizacao === 'mapa' ? (
            <GradeQuadraLote
              imoveis={imoveis}
              onLoteDoubleClick={handleLoteDoubleClick}
              onLoteContextMenu={handleLoteContextMenu}
              onLoteClick={handleLoteClick}
              loading={loading}
              filtrosStatus={filtrosStatus}
            />
          ) : (
            <GridTabularImoveis
              imoveis={imoveis}
              onLoteDoubleClick={handleLoteDoubleClick}
              onLoteContextMenu={handleLoteContextMenu}
              filtrosStatus={filtrosStatus}
              loading={loading}
            />
          )}
        </Card.Body>
        {ativosSemQuadra.length > 0 && (
          <PainelSemQuadra
            ativos={ativosSemQuadra}
            onInativar={handleBuscar}
          />
        )}
        <LegendaContadores
          contadores={contadores}
          filtrosStatus={filtrosStatus}
          onFiltrar={setFiltrosStatus}
        />
      </Card>

      <ModalDetalhe
        show={modalDetalhe}
        onHide={() => setModalDetalhe(false)}
        detalhe={loadingDetalhe ? null : detalhe}
        imovelMapa={imovelMapaSel}
        codigoFamilia={empreendimentoSelecionado ? empreendimentoSelecionado.value : 0}
        onAlterarStatus={handleAlterarStatus}
        controlaPropostaVda={controlaPropostaVda}
        onRecarregar={handleBuscar}
      />

      <MenuContexto
        visible={menuCtx.visible}
        x={menuCtx.x}
        y={menuCtx.y}
        imovel={menuCtx.imovel}
        onAction={handleMenuAction}
        onClose={() => setMenuCtx({ visible: false, x: 0, y: 0, imovel: null })}
        controlaPropostaVda={controlaPropostaVda}
      />

      <ModalVincularProposta
        show={modalProposta}
        onHide={() => setModalProposta(false)}
        imovel={imovelProposta}
        onVincular={handleVincularProposta}
      />
    </Container>
  );
};

export default ConsultaImoveis;
